import type { ShareCopy } from './share-flow';

// App sharing's half of the share-dialog machine: the copy, and nothing else.
//
// The logic lives in `lib/share-flow.ts` and is shared, deliberately — the rules it holds (a typo
// mints a person, "nothing was written" is a third outcome, a failed list read is not "private",
// a repeat share announced nothing on purpose) are not about apps or files, and two copies of them
// drift with only one getting the next fix. This file exists so that generic machine never has to
// know what a mini-app is.
export const APP_SHARE_COPY: ShareCopy = {
  invalidEmail: 'apps.share.invalidEmail',
  shareFailed: 'apps.share.failed',
  removeFailed: 'apps.share.removeFailed',
  private: 'apps.share.private',
  privateHint: 'apps.share.privateHint',
  sharedWithOne: 'apps.share.sharedWith.one',
  sharedWithOther: 'apps.share.sharedWith.other',
  loadFailed: 'apps.share.loadFailed',
  retry: 'apps.share.retry',
  unnamed: 'apps.share.unnamed',
};
